import { combineReducers, configureStore } from '@reduxjs/toolkit';
import userReducer from './reducers/userReducer';
import gamesReducer from './reducers/gamesReducer';
import appReducer from './reducers/appReducer';
import thunkMiddleware from 'redux-thunk';
import loggerMiddleware from 'redux-logger';
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';
import { encryptTransform } from 'redux-persist-transform-encrypt';
import {languageDetectorMiddleware} from "../middlewares/languageDetectorMiddleware";

const encryptor = encryptTransform({
	secretKey: 'tigsipay-secret-key-storage-phrase',
	onError: function (error) {
		console.error('Error while encrypting:', error);
	},
});

const userPersistConfig = {
	key: 'user',
	storage: storage,
	transforms: [encryptor],
};

const appPersistConfig = {
	key: 'app',
	storage: storage,
	transforms: [encryptor],
	whitelist: ['language', 'theme'],
};
const cartPersistConfig = {
	key: 'cart',
	storage: storage,
	timeout: 50000,
};

const rootReducer = combineReducers({
	user: persistReducer(userPersistConfig, userReducer),
	games: persistReducer(cartPersistConfig, gamesReducer),
	app: persistReducer(appPersistConfig, appReducer),
});

const middleware = [thunkMiddleware, languageDetectorMiddleware];
if (process.env.NODE_ENV === 'development') {
	middleware.push(loggerMiddleware);
}

const store = configureStore({
	reducer: rootReducer,
	middleware,
});

const persistor = persistStore(store);

export { store, persistor };
